import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";
import type { EditorFieldProps } from "../../../Editor/DefaultEditorFields";
import { FormTipTapEditor } from "./FormTiptapEditor";

export const RichTextField = ({ name, propMeta }: EditorFieldProps) => {
  const fallbackLabel = propMeta.name;
  const i18nKey = propMeta.nameI18n;
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  const label = i18nKey
    ? t(i18nKey, { defaultValue: fallbackLabel })
    : fallbackLabel;

  return (
    <Form.Item
      name={name}
      label={label}
      hideDescription
      hideBorder
      className="!p-0"
      labelClassName={classNames({
        "!text-dark !text-xs !font-normal": isPropertiesPanelV2,
      })}
    >
      <FormTipTapEditor name={name} />
    </Form.Item>
  );
};
